import { useState } from "react";

const COL_LABELS = {
  "60 E":   "60 Essence",
  "60":     "60 Selection",
  "60 SL":  "60 Sportline",
  "85":     "85 Selection",
  "85x":    "85x Selection",
  "85 SL":  "85 Sportline",
  "85x SL": "85x Sportline",
  "RS":     "RS",
};
const COLS = ["60 E", "60", "60 SL", "85", "85x", "85 SL", "85x SL", "RS"];

const COL_COLORS = {
  "60 E":   "#10b981",
  "60":     "#3b82f6",
  "60 SL":  "#6366f1",
  "85":     "#d4d4d4",
  "85x":    "#94a3b8",
  "85 SL":  "#f59e0b",
  "85x SL": "#d97706",
  "RS":     "#ef4444",
};

// Vorausgefüllte MY27-Werte aus internem Škoda-Dokument (Stand 23.03.2026)
// Nur Technik – Preise stehen noch aus ("folgt" laut Dokument)
const INITIAL_MY27 = {
  // Batterietyp
  "t_batterie__60":     "LFP",
  "t_batterie__60 SL":  "LFP",
  "t_batterie__85":     "NMC",
  "t_batterie__85x":    "NMC",
  "t_batterie__85 SL":  "NMC",
  "t_batterie__85x SL": "NMC",
  "t_batterie__RS":     "NMC",
  // Max kW
  "t_maxkw__60":     "140 kW",
  "t_maxkw__60 SL":  "140 kW",
  "t_maxkw__85":     "210 kW",
  "t_maxkw__85x":    "220 kW",
  "t_maxkw__85 SL":  "210 kW",
  "t_maxkw__85x SL": "220 kW",
  "t_maxkw__RS":     "250 kW",
  // Leistung
  "t_leistung__60":     "140 kW / 190 PS",
  "t_leistung__60 SL":  "140 kW / 190 PS",
  "t_leistung__85":     "210 kW / 286 PS",
  "t_leistung__85x":    "220 kW / 299 PS",
  "t_leistung__85 SL":  "210 kW / 286 PS",
  "t_leistung__85x SL": "220 kW / 299 PS",
  "t_leistung__RS":     "250 kW / 340 PS",
  // Akku netto
  "t_akku__60":     "58 kWh",
  "t_akku__60 SL":  "58 kWh",
  "t_akku__85":     "77 kWh",
  "t_akku__85x":    "77 kWh",
  "t_akku__85 SL":  "77 kWh",
  "t_akku__85x SL": "77 kWh",
  "t_akku__RS":     "77 kWh",
  // Max. DC-Ladeleistung
  "t_dc__60":     "max. 105 kW",
  "t_dc__60 SL":  "max. 105 kW",
  "t_dc__85":     "165 kW",
  "t_dc__85x":    "165 kW",
  "t_dc__85 SL":  "165 kW",
  "t_dc__85x SL": "165 kW",
  "t_dc__RS":     "165 kW",
  // Reichweite
  "t_range__60":     "ca. 450 km",
  "t_range__60 SL":  "ca. 450 km",
  "t_range__85":     "531–573 km",
  "t_range__85x":    "503–540 km",
  "t_range__85 SL":  "532–562 km",
  "t_range__85x SL": "503–529 km",
  "t_range__RS":     "ca. 562 km",
  // Sprint zusaetzlich
  "t_sprint__85":     "6,6 s",
  "t_sprint__85x":    "6,2 s",
  "t_sprint__85 SL":  "6,6 s",
  "t_sprint__85x SL": "6,2 s",
  // Vmax
  "t_vmax__60":     "160 km/h",
  "t_vmax__60 SL":  "160 km/h",
  "t_vmax__85":     "180 km/h",
  "t_vmax__85x":    "180 km/h",
  "t_vmax__85 SL":  "180 km/h",
  "t_vmax__85x SL": "180 km/h",
  "t_vmax__RS":     "180 km/h",
  // 0-100 km/h
  "t_sprint__60":     "8,5 s",
  "t_sprint__60 SL":  "8,5 s",
  "t_sprint__RS":     "5,4 s",
  // 60 Essence (neu MY27)
  "t_batterie__60 E":  "LFP",
  "t_maxkw__60 E":     "140 kW",
  "t_leistung__60 E":  "140 kW / 190 PS",
  "t_akku__60 E":      "58 kWh",
  "t_dc__60 E":        "165 kW",
  "t_range__60 E":     "577 km",
  "t_vmax__60 E":      "160 km/h",
  "t_sprint__60 E":    "8,5 s",
};

const CATEGORIES = [
  {
    id: "technik",
    label: "Technische Daten",
    icon: "⚡",
    items: [
      { id: "t_batterie", label: "Batterietyp", type: "text",
        my26: { "60 E": null, "60": "NMC", "60 SL": "NMC", "85": "NMC", "85x": "NMC", "85 SL": "NMC", "85x SL": "NMC", "RS": "NMC" } },
      { id: "t_maxkw", label: "Max. Leistung (kW)", type: "text",
        my26: { "60 E": null, "60": "150 kW", "60 SL": "150 kW", "85": "210 kW", "85x": "210 kW", "85 SL": "210 kW", "85x SL": "210 kW", "RS": "250 kW" } },
      { id: "t_leistung", label: "Leistung (kW / PS)", type: "text",
        my26: { "60 E": null, "60": "150 kW / 204 PS", "60 SL": "150 kW / 204 PS", "85": "210 kW / 286 PS", "85x": "210 kW / 286 PS", "85 SL": "210 kW / 286 PS", "85x SL": "210 kW / 286 PS", "RS": "250 kW / 340 PS" } },
      { id: "t_akku", label: "Akku netto (kWh)", type: "text",
        my26: { "60 E": null, "60": "59 kWh", "60 SL": "59 kWh", "85": "77 kWh", "85x": "77 kWh", "85 SL": "77 kWh", "85x SL": "77 kWh", "RS": "79 kWh" } },
      { id: "t_dc", label: "Max. DC-Ladeleistung", type: "text",
        my26: { "60 E": null, "60": "165 kW", "60 SL": "165 kW", "85": "135 kW", "85x": "175 kW", "85 SL": "135 kW", "85x SL": "175 kW", "RS": "185 kW" } },
      { id: "t_range", label: "Reichweite WLTP (kombiniert)", type: "text",
        my26: { "60 E": null, "60": "394–429 km", "60 SL": "394–424 km", "85": "531–573 km", "85x": "503–540 km", "85 SL": "532–562 km", "85x SL": "503–529 km", "RS": "523–546 km" } },
      { id: "t_vmax", label: "Höchstgeschwindigkeit", type: "text",
        my26: { "60 E": null, "60": "160 km/h", "60 SL": "160 km/h", "85": "180 km/h", "85x": "180 km/h", "85 SL": "180 km/h", "85x SL": "180 km/h", "RS": "180 km/h" } },
      { id: "t_sprint", label: "0–100 km/h", type: "text",
        my26: { "60 E": null, "60": "8,0 s", "60 SL": "8,0 s", "85": "6,8 s", "85x": "5,9 s", "85 SL": "6,8 s", "85x SL": "5,9 s", "RS": "5,4 s" } },
    ],
  },
  {
    id: "modelle",
    label: "Modellpreise",
    icon: "🚗",
    items: [
      { id: "m_60e",   label: "Elroq 60 Essence (Heck, 140 kW)",      label27: "Elroq 60 Essence (Heck, 140 kW)",      my26: { "–": null }, newMY27: true },
      { id: "m_60",    label: "Elroq 60 (Heck, 150 kW)",            label27: "Elroq 60 Selection (Heck, 140 kW)",   my26: { "–": 38680 } },
      { id: "m_60sl",  label: "Elroq 60 Sportline (Heck, 150 kW)",   label27: "Elroq 60 Sportline (Heck, 140 kW)",   my26: { "–": 44100 } },
      { id: "m_85",    label: "Elroq 85 (Heck, 210 kW)",             label27: "Elroq 85 Selection (Heck, 210 kW)",   my26: { "–": 44180 } },
      { id: "m_85x",   label: "Elroq 85x (Allrad, 210 kW)",          label27: "Elroq 85x Selection (Allrad, 220 kW)", my26: { "–": 46450 } },
      { id: "m_85sl",  label: "Elroq 85 Sportline (Heck, 210 kW)",   label27: "Elroq 85 Sportline (Heck, 210 kW)",   my26: { "–": 48400 } },
      { id: "m_85xsl", label: "Elroq 85x Sportline (Allrad, 210 kW)", label27: "Elroq 85x Sportline (Allrad, 220 kW)", my26: { "–": 50670 } },
      { id: "m_rs",    label: "Elroq RS (Allrad, 250 kW)",            label27: "Elroq RS (Allrad, 250 kW)",            my26: { "–": 53050 } },
    ],
  },
  {
    id: "lack",
    label: "Lackierung",
    icon: "🎨",
    items: [
      { id: "lack_basis",    label: "Energy-Blau (Basisfarbe)",
        my26: { "60 E": null, "60": 0, "60 SL": 0, "85": 0, "85x": 0, "85 SL": 0, "85x SL": 0, "RS": 0 } },
      { id: "lack_metallic", label: "Metallic / Perleffekt",
        my26: { "60 E": null, "60": 660, "60 SL": 660, "85": 660, "85x": 660, "85 SL": 660, "85x SL": 660, "RS": 660 } },
      { id: "lack_dach",     label: "Dachkontrastlackierung",
        my26: { "60 E": null, "60": null, "60 SL": null, "85": null, "85x": null, "85 SL": 1330, "85x SL": 1330, "RS": 1330 } },
      { id: "lack_matt",     label: "Mattlackierung Graphite-Grau (nur RS)",
        my26: { "60 E": null, "60": null, "60 SL": null, "85": null, "85x": null, "85 SL": null, "85x SL": null, "RS": null } },
    ],
  },
  {
    id: "felgen",
    label: "Felgen",
    icon: "○",
    items: [
      { id: "f_stahl",       label: '19" Stahlfelgen (Basis)',
        my26: { "60 E": null, "60": 0, "60 SL": null, "85": null, "85x": null, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "f_proteus",     label: '19" Proteus',
        my26: { "60 E": null, "60": 530, "60 SL": null, "85": 0, "85x": 0, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "f_regulus",     label: '19" Regulus Anthrazit glanzgedreht',
        my26: { "60 E": null, "60": 190, "60 SL": null, "85": 190, "85x": 190, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "f_vega_sw",     label: '20" Vega Schwarz glanzgedreht',
        my26: { "60 E": null, "60": null, "60 SL": 0, "85": null, "85x": null, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "f_vega",        label: '20" Vega',
        my26: { "60 E": null, "60": 540, "60 SL": null, "85": 540, "85x": 540, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "f_neptune",     label: '20" Neptune Anthrazit glanzgedreht',
        my26: { "60 E": null, "60": 790, "60 SL": null, "85": 790, "85x": 790, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "f_draconis",    label: '20" Draconis Schwarz',
        my26: { "60 E": null, "60": null, "60 SL": null, "85": null, "85x": null, "85 SL": 0, "85x SL": 0, "RS": 0 } },
      { id: "f_supernova_a", label: '21" Supernova Anthrazit glanzgedreht',
        my26: { "60 E": null, "60": 1440, "60 SL": null, "85": 1440, "85x": 1440, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "f_supernova_s", label: '21" Supernova Schwarz glanzgedreht',
        my26: { "60 E": null, "60": null, "60 SL": 710, "85": null, "85x": null, "85 SL": 710, "85x SL": 710, "RS": null } },
      { id: "f_vision",      label: '21" Vision Anthrazit glanzgedreht',
        my26: { "60 E": null, "60": null, "60 SL": null, "85": null, "85x": null, "85 SL": null, "85x SL": null, "RS": 790 } },
    ],
  },
  {
    id: "design",
    label: "Design Selections (Interieur)",
    icon: "🪑",
    items: [
      { id: "studio",        label: "Studio (Stoff, Basis)",
        my26: { "60 E": null, "60": 0, "60 SL": null, "85": null, "85x": null, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "loft",          label: "Loft (Kunstleder, Moosgrün)",
        my26: { "60 E": null, "60": 0, "60 SL": null, "85": 0, "85x": 0, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "lodge",         label: "Lodge (Kunstleder, Orange)",
        my26: { "60 E": null, "60": 630, "60 SL": null, "85": 630, "85x": 630, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "suite",         label: "Suite (Leder-Kunstleder, Cognac)",
        my26: { "60 E": null, "60": 2160, "60 SL": null, "85": 2160, "85x": 2160, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "lk",            label: "L&K (Leder Beige, Cognac)",
        my26: { "60 E": null, "60": 2460, "60 SL": null, "85": 2460, "85x": 2460, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "sportline_int", label: "Sportline Interieur (Microfaser, Ziernähte Grau)",
        my26: { "60 E": null, "60": null, "60 SL": 0, "85": null, "85x": null, "85 SL": 0, "85x SL": 0, "RS": null } },
      { id: "rs_lounge",     label: "RS Lounge (Microfaser, Ziernähte Lime-Grün)",
        my26: { "60 E": null, "60": null, "60 SL": null, "85": null, "85x": null, "85 SL": null, "85x SL": null, "RS": 0 } },
    ],
  },
  {
    id: "pakete",
    label: "Ausstattungspakete",
    icon: "📦",
    items: [
      { id: "smart",     label: "Smart-Paket",
        my26: { "60 E": null, "60": 1510, "60 SL": 0, "85": 0, "85x": 0, "85 SL": 0, "85x SL": 0, "RS": 0 } },
      { id: "clever",    label: "Clever-Paket",
        my26: { "60 E": null, "60": 2390, "60 SL": 0, "85": 1040, "85x": 1040, "85 SL": 0, "85x SL": 0, "RS": 0 } },
      { id: "plus",      label: "Plus-Paket",
        my26: { "60 E": null, "60": 4070, "60 SL": 0, "85": 2790, "85x": 2790, "85 SL": 0, "85x SL": 0, "RS": 0 } },
      { id: "advanced",  label: "Advanced-Paket",
        my26: { "60 E": null, "60": 6350, "60 SL": 2110, "85": 5160, "85x": 5160, "85 SL": 2550, "85x SL": 2550, "RS": 0 } },
      { id: "maxx",      label: "Maxx-Paket",
        my26: { "60 E": null, "60": 7410, "60 SL": 3150, "85": 6210, "85x": 6210, "85 SL": 3590, "85x SL": 3590, "RS": 1070 } },
      { id: "winter",    label: "Winterpaket",
        my26: { "60 E": null, "60": 770, "60 SL": 590, "85": 590, "85x": 590, "85 SL": 590, "85x SL": 590, "RS": 590 } },
      { id: "transport", label: "Transport-Paket", hint: "MY27: inkl. 230V Steckdose",
        my26: { "60 E": null, "60": 290, "60 SL": 290, "85": 290, "85x": 290, "85 SL": 290, "85x SL": 290, "RS": null } },
      { id: "sport",     label: "Sport-Paket (DCC + Progressivlenkung)",
        my26: { "60 E": null, "60": 1160, "60 SL": 770, "85": 960, "85x": 960, "85 SL": 770, "85x SL": 770, "RS": 0 } },
      { id: "chrom",     label: "Chrom-Paket (Dachreling + Fensterleisten)",
        my26: { "60 E": null, "60": 410, "60 SL": null, "85": null, "85x": null, "85 SL": null, "85x SL": null, "RS": null } },
      { id: "simply_clever", label: "Simply Clever Paket", hint: "Neu ab MY27",
        my26: { "60 E": null, "60": null, "60 SL": null, "85": null, "85x": null, "85 SL": null, "85x SL": null, "RS": null } },
    ],
  },
  {
    id: "sonder",
    label: "Sonderausstattung",
    icon: "🔧",
    items: [
      { id: "waermepumpe", label: "Wärmepumpe",
        my26: { "60 E": null, "60": 1080, "60 SL": 1080, "85": 1080, "85x": 1080, "85 SL": 1080, "85x SL": 1080, "RS": 1080 } },
      { id: "ahk",         label: "Schwenkbare AHK",
        my26: { "60 E": null, "60": 870, "60 SL": 700, "85": 700, "85x": 700, "85 SL": 700, "85x SL": 700, "RS": 700 } },
      { id: "charger",     label: "Universal Charger (mobile Ladestation)",
        my26: { "60 E": null, "60": 630, "60 SL": 630, "85": 630, "85x": 630, "85 SL": 630, "85x SL": 630, "RS": 630 } },
      { id: "netz",        label: "Gepäcknetztrennwand",
        my26: { "60 E": null, "60": 160, "60 SL": 160, "85": 160, "85x": 160, "85 SL": 160, "85x SL": 160, "RS": 160 } },
    ],
  },
];

// Basis = 0 EUR, aber durch andere Option ersetzbar (Lack, Felgen, Design)
// Serie = immer dabei, nicht abwaehlbar (Pakete, Assistenten etc.)
const BASIS_ITEMS = new Set([
  "lack_basis",
  "f_stahl", "f_proteus", "f_vega_sw", "f_draconis",
  "studio", "loft",
  "lack_basis",
]);

// ── MY27 Offizielle Preise (Stand 23.04.2026) ───────────────────────────────
const MY27_PREFILLED = {
  // ── MODELLPREISE ──────────────────────────────────────────────────────────
  "m_60e__–":   "37390",   // NEU: 60 Essence
  "m_60__–":    "41890",   // 60 Selection (MY26: 38.680)
  "m_60sl__–":  "45490",   // 60 Sportline (MY26: 44.100)
  "m_85__–":    "46390",   // 85 Selection (MY26: 44.180)
  "m_85x__–":   "48690",   // 85x Selection (MY26: 46.450)
  "m_85sl__–":  "49990",   // 85 Sportline (MY26: 48.400)
  "m_85xsl__–": "52290",   // 85x Sportline (MY26: 50.670)
  "m_rs__–":    "54790",   // RS (MY26: 53.050)
  // ── PAKETE ────────────────────────────────────────────────────────────────
  // Smart
  "smart__60 E": "1520",  "smart__60": "0",  "smart__85": "0", "smart__85x": "0", "smart__RS": "0", "clever__RS": "0", "plus__RS": "0", "advanced__RS": "0", "sport__RS": "0", "smart__60 SL": "0", "smart__85 SL": "0", "smart__85x SL": "0",     "smart__60 SL": "0",
  "smart__85":   "0",     "smart__85x": "0",    "smart__85 SL": "0",
  "smart__85x SL": "0",   "smart__RS":  "0",
  // Clever
  "clever__60":  "0",     "clever__60 SL": "0",  "clever__85 SL": "0",  "clever__85x SL": "0",
  "clever__85":  "0",     "clever__85x": "0",   "clever__85 SL": "0",
  "clever__85x SL": "0",  "clever__RS":  "0",
  // Plus
  "plus__60":    "1870",  "plus__60 SL": "0",  "plus__85 SL": "0",  "plus__85x SL": "0",
  "plus__85":    "1870",  "plus__85x":   "1870", "plus__85 SL": "0",
  "plus__85x SL": "0",    "plus__RS":    "0",
  // Advanced
  "advanced__60":    "4210", "advanced__60 SL": "2020",
  "advanced__85":    "4210", "advanced__85x":   "4210",
  "advanced__85 SL": "2020", "advanced__85x SL": "2020",
  "advanced__RS":    "0",
  // Maxx
  "maxx__60":    "5280",  "maxx__60 SL": "3090",
  "maxx__85":    "5280",  "maxx__85x":   "5280",
  "maxx__85 SL": "3090",  "maxx__85x SL": "3090",
  "maxx__RS":    "1070",
  // Winter (RS jetzt SERIE!)
  "winter__60":  "590",  "winter__60 SL": "590",
  "winter__85":  "590",  "winter__85x": "590",  "winter__85 SL": "590",
  "winter__85x SL": "590", "winter__RS": "0",
  // Transport (MY27: 480€, inkl. 230V Steckdose; RS neu 340€)
  "transport__60 E": "480", "transport__60": "480", "transport__60 SL": "480",
  "transport__85": "480",   "transport__85x": "480",
  "transport__85 SL": "480", "transport__85x SL": "480",
  "transport__RS": "340",
  // Sport
  "sport__60": "980",  "sport__60 SL": "780",   "sport__85":  "980",  "sport__85x": "980",
  "sport__85 SL": "780",   "sport__85x SL": "780", "sport__RS": "0",
  // Simply Clever (NEU ab MY27)
  "simply_clever__60":    "70",  "simply_clever__60 SL": "70",
  "simply_clever__85":    "70",  "simply_clever__85x":   "70",
  "simply_clever__85 SL": "70",  "simply_clever__85x SL": "70",
  "simply_clever__RS":    "70",
  // ── LACKIERUNG ────────────────────────────────────────────────────────────
  "lack_metallic__60 E": "740", "lack_metallic__60": "740", "lack_metallic__60 SL": "740",
  "lack_metallic__85": "740",   "lack_metallic__85x": "740",
  "lack_metallic__85 SL": "740", "lack_metallic__85x SL": "740",
  "lack_metallic__RS": "740",
  "lack_dach__60 SL": "1420",
  "lack_dach__85 SL": "1420",   "lack_dach__85x SL": "1420",
  "lack_dach__RS": "1420",
  "lack_matt__RS": "1660",
  "chrom__60": "X",
  // ── FELGEN ────────────────────────────────────────────────────────────────
  "f_stahl__60 E": "0",  "f_stahl__60": "0",
  "f_proteus__60 E": "540",  "f_proteus__60": "0",   "f_proteus__85": "0",  "f_proteus__85x": "0",
  "f_regulus__60 E": "740",  "f_regulus__60": "200", "f_regulus__85": "200", "f_regulus__85x": "200",
  "f_vega_sw__60 SL": "0",
  "f_vega__60": "550",       "f_vega__85": "550",    "f_vega__85x": "550",
  "f_neptune__60": "810",    "f_neptune__85": "810", "f_neptune__85x": "810",
  "f_draconis__85 SL": "0",  "f_draconis__85x SL": "0",  "f_draconis__RS": "0",
  "f_supernova_a__60": "1460", "f_supernova_a__85": "1460", "f_supernova_a__85x": "1460",
  "f_supernova_s__60 SL": "710", "f_supernova_s__85 SL": "710", "f_supernova_s__85x SL": "710",
  "f_vision__RS": "800",
  // ── DESIGN SELECTIONS ─────────────────────────────────────────────────────
  "lack_basis__60 E": "0", "lack_basis__60": "0", "lack_basis__60 SL": "0", "lack_basis__85": "0", "lack_basis__85x": "0", "lack_basis__85 SL": "0", "lack_basis__85x SL": "0", "lack_basis__RS": "0",
  "studio__60 E": "0",
  "loft__60": "0",       "loft__85": "0",       "loft__85x": "0",
  "lodge__60": "640",    "lodge__85": "640",    "lodge__85x": "640",
  "suite__60": "2190",   "suite__85": "2190",   "suite__85x": "2190",
  "lk__60": "2490",      "lk__85": "2490",      "lk__85x": "2490",
  "studio__60 E": "0",
  "sportline_int__60 SL": "0", "sportline_int__85 SL": "0", "sportline_int__85x SL": "0",
  "rs_lounge__RS": "0",
  // ── SONDERAUSSTATTUNG ──────────────────────────────────────────────────────
  "waermepumpe__60 E": "1110",  "waermepumpe__60": "1110",   "waermepumpe__60 SL": "1110",
  "waermepumpe__85": "1110",   "waermepumpe__85x": "1110",
  "waermepumpe__85 SL": "1110", "waermepumpe__85x SL": "1110",
  "waermepumpe__RS": "1110",
  "ahk__60 E": "890",  "ahk__60": "720",     "ahk__60 SL": "720",   "ahk__85": "720",
  "ahk__85x": "720",    "ahk__85 SL": "720",   "ahk__85x SL": "720",
  "ahk__RS": "720",
  "charger__60": "640", "charger__60 SL": "640", "charger__85": "640",
  "charger__85x": "640", "charger__85 SL": "640", "charger__85x SL": "640",
  "charger__RS": "640",
  "netz__60 E": "160",  "netz__60": "160",    "netz__60 SL": "160",  "netz__85": "160",
  "netz__85x": "160",   "netz__85 SL": "160",  "netz__85x SL": "160",
  "netz__RS": "160",
};

// Bedingte MY27-Preise: Transport/Winter günstiger wenn Advanced oder Maxx gewählt
// Positionen die in MY27 Serie sind aber nicht anklickbar (da MY26 kostenpflichtig war)
const MY27_SERIE_ONLY = new Set(["winter__RS", "smart__60", "smart__85", "smart__85x", "smart__RS", "clever__60", "clever__RS", "plus__RS", "advanced__RS", "sport__RS", "clever__85", "clever__85x", "studio__60 E", "smart__60 SL", "smart__85 SL", "smart__85x SL", "clever__60 SL", "clever__85 SL", "clever__85x SL", "plus__60 SL", "plus__85 SL", "plus__85x SL", "sportline_int__60 SL", "sportline_int__85 SL", "sportline_int__85x SL", "rs_lounge__RS"]);
const MY27_BASIS_ONLY = new Set(["f_proteus__85x", "f_vega_sw__60 SL", "f_draconis__60 SL", "f_draconis__85 SL", "f_draconis__85x SL", "f_draconis__RS", "lack_basis__60 E", "lack_basis__60", "lack_basis__60 SL", "lack_basis__85", "lack_basis__85x", "lack_basis__85 SL", "lack_basis__85x SL", "lack_basis__RS", "f_stahl__60 E", "f_stahl__60", "f_proteus__85", "f_proteus__60", "loft__60", "loft__85", "loft__85x"]);
const MY27_UNAVAILABLE = new Set(["chrom__60", "lack_dach__60", "lack_dach__85", "lack_dach__85x"]);

function getConditionalPrice(itemId, col, my27State) {
  const advKey = "advanced__" + col;
  const maxxKey = "maxx__" + col;
  const advSel = my27State[advKey];
  const maxxSel = my27State[maxxKey];
  const hasAdv = advSel && advSel !== "";
  const hasMaxx = maxxSel && maxxSel !== "";

  // Gilt nur für Selection und Sportline (nicht 60E, nicht RS)
  const eligible = ["60", "60 SL", "85", "85x", "85 SL", "85x SL"].includes(col);
  if (!eligible) return null;

  if (itemId === "transport") {
    if (hasAdv || hasMaxx) return "340";
  }
  if (itemId === "winter") {
    if (hasMaxx) return "390";
  }
  return null;
}

function getConditionalPrice26(itemId, col, my27State) {
  const maxxKey = "maxx__" + col;
  const hasMaxx = my27State[maxxKey] && my27State[maxxKey] !== "";
  const eligible = ["85", "85x", "85 SL", "85x SL"].includes(col);
  if (itemId === "winter" && eligible && hasMaxx) return 340;
  return null;
}

function fmtPrice(val, itemId) {
  if (val === null || val === undefined) return null;
  if (val === 0 && BASIS_ITEMS.has(itemId)) return "__BASIS__";
  if (val === 0) return "__SERIE__";
  return val.toLocaleString("de-DE") + " €";
}

function badge(bg, color, extra) {
  return { background: bg, color, padding: "2px 5px", borderRadius: 4, fontSize: 10, fontWeight: 700, whiteSpace: "nowrap", ...extra };
}

function PriceDiff({ my26, my27raw }) {
  if (!my27raw && my27raw !== "0") return <span style={{ color: "#2a2a2a" }}>—</span>;
  const isSerie = ["serie","Serie","0"].includes(String(my27raw).trim());
  const v27 = isSerie ? 0 : parseInt(my27raw);
  const v26 = my26 === 0 ? 0 : (my26 ?? 0);
  if (isNaN(v27)) return null;
  const diff = v27 - v26;
  if (diff === 0) return <span style={badge("#1e3a2e","#4ade80")}>= gleich</span>;
  if (diff > 0)   return <span style={badge("#3a1e1e","#f87171")}>+{diff.toLocaleString("de-DE")} €</span>;
  return             <span style={badge("#1e2e3a","#60a5fa")}>{diff.toLocaleString("de-DE")} €</span>;
}

// Felder bei denen ein HOEHERER Wert besser ist (Zahl extrahieren und vergleichen)
const HIGHER_BETTER = new Set(["t_maxkw","t_leistung","t_akku","t_dc","t_range","t_vmax"]);
// Felder bei denen ein NIEDRIGERER Wert besser ist
const LOWER_BETTER  = new Set(["t_sprint"]);

function extractNum(str) {
  const m = String(str).replace(",",".").match(/[\d]+\.?[\d]*/);
  return m ? parseFloat(m[0]) : null;
}

function TextDiff({ my26, my27raw, itemId }) {
  if (!my27raw) return <span style={{ color: "#2a2a2a" }}>—</span>;
  if (my27raw.trim() === String(my26).trim()) return <span style={badge("#1e3a2e","#4ade80")}>= gleich</span>;

  const n26 = extractNum(my26);
  const n27 = extractNum(my27raw);

  if (n26 !== null && n27 !== null && HIGHER_BETTER.has(itemId)) {
    if (n27 > n26) return <span style={badge("#2a1e0e","#fbbf24")}>↑ {my27raw}</span>;
    if (n27 < n26) return <span style={badge("#2a1e0e","#fbbf24")}>↓ {my27raw}</span>;
  }
  if (n26 !== null && n27 !== null && LOWER_BETTER.has(itemId)) {
    if (n27 < n26) return <span style={badge("#2a1e0e","#fbbf24")}>↑ {my27raw}</span>;
    if (n27 > n26) return <span style={badge("#2a1e0e","#fbbf24")}>↓ {my27raw}</span>;
  }
  return <span style={badge("#2a1e0e","#fbbf24")}>→ {my27raw}</span>;
}

const inputStyle = (filled) => ({
  width: "100%", minWidth: 0,
  background: filled ? "#1a2a1a" : "#1a1a1a",
  border: `1px solid ${filled ? "#2d4a2d" : "#30363d"}`,
  borderRadius: 4,
  color: filled ? "#e8e8e8" : "#333",
  padding: "3px 3px", fontSize: 10, textAlign: "center",
  outline: "none", boxSizing: "border-box",
});

const thS = (color) => ({
  padding: "3px 3px", textAlign: "center",
  fontWeight: 700, fontSize: 9, whiteSpace: "nowrap", color,
});

// ── Kalkulator Hilfsdaten ───────────────────────────────────────────────────
const MODEL_COL_MAP = {
  "m_60e": "60 E", "m_60": "60", "m_60sl": "60 SL", "m_85": "85", "m_85x": "85x",
  "m_85sl": "85 SL", "m_85xsl": "85x SL", "m_rs": "RS",
};
// Umgekehrt: Spalte → Modell-Item-ID
const COL_TO_MODEL_ID = {
  "60 E": "m_60e", "60": "m_60", "60 SL": "m_60sl", "85": "m_85", "85x": "m_85x",
  "85 SL": "m_85sl", "85x SL": "m_85xsl", "RS": "m_rs",
};

function buildMY26Lookup() {
  const map = {};
  for (const cat of CATEGORIES) {
    for (const item of cat.items) {
      for (const [col, val] of Object.entries(item.my26)) {
        map[item.id + "__" + col] = val;
      }
    }
  }
  return map;
}
const MY26_LOOKUP = buildMY26Lookup();

function parsePrice(val) {
  if (!val && val !== 0) return null;
  const s = String(val).trim().toLowerCase();
  if (s === "serie" || s === "0") return 0;
  const n = parseInt(s.replace(/[^0-9]/g, ""));
  return isNaN(n) ? null : n;
}

function useKalkulator(my27State, my26SelState, my26Lookup) {
  // Collect all entered MY27 price entries (exclude technik text fields)
  const entries = [];
  for (const [key, val] of Object.entries(my27State)) {
    if (!val) continue;
    const parts = key.split("__");
    if (parts.length < 2) continue;
    const itemId = parts[0];
    const col = parts.slice(1).join("__");
    // Skip technik (text) and helper fields
    if (itemId.startsWith("t_")) continue;
    if (col === "__kw" || col === "__antrieb") continue;
    const v27 = parsePrice(val);
    if (v27 === null) continue;
    // Resolve effective model column
    const effCol = col === "–" ? (MODEL_COL_MAP[itemId] || null) : col;
    if (!effCol) continue;
    // Get MY26 value
    const v26raw = MY26_LOOKUP[key];
    if (v26raw === null || v26raw === undefined) continue;
    const v26 = v26raw === 0 ? 0 : v26raw;
    if (typeof v26 !== "number") continue;
    entries.push({ itemId, col, effCol, v26, v27 });
  }

  // Count entries per model column
  const colCounts = {};
  for (const e of entries) {
    colCounts[e.effCol] = (colCounts[e.effCol] || 0) + 1;
  }

  const activeCols = Object.entries(colCounts).sort((a, b) => b[1] - a[1]);
  const multiModel = activeCols.length > 1;
  const activeCol = activeCols[0]?.[0] || null;

  // Sum only entries for the dominant model column
  let sum26 = 0, sum27 = 0;
  const eligible26cols = ["60", "60 SL", "85", "85x", "85 SL", "85x SL"];
  for (const e of entries) {
    if (e.effCol !== activeCol) continue;
    let v26used = e.v26;
    // Transport MY26: gratis wenn Advanced oder Maxx gewählt
    if (e.itemId === "transport" && eligible26cols.includes(e.effCol)) {
      const advKey = "advanced__" + e.effCol;
      const maxxKey = "maxx__" + e.effCol;
      if ((my27State[advKey] && my27State[advKey] !== "") || (my27State[maxxKey] && my27State[maxxKey] !== "")) {
        v26used = 0;
      }
    }
    // Winter MY26: reduziert wenn Maxx gewählt (85er Varianten)
    const condP26 = getConditionalPrice26(e.itemId, e.effCol, my27State);
    if (condP26 !== null) v26used = condP26;
    sum26 += v26used;
    sum27 += e.v27;
  }
  // MY26 manuell angewählte Positionen addieren (items jetzt Serie in MY27)
  for (const [key, sel] of Object.entries(my26SelState || {})) {
    if (!sel) continue;
    const v26extra = my26Lookup[key];
    if (typeof v26extra === "number" && v26extra > 0) sum26 += v26extra;
  }

  const count = entries.filter(e => e.effCol === activeCol).length;
  return { activeCol, sum26, sum27, diff: sum27 - sum26, count, multiModel, activeCols };
}

export default function App() {
  const [my27, setMy27] = useState({ ...INITIAL_MY27 });
  const [my26sel, setMy26sel] = useState({});  // MY26 zusätzlich angewählte Positionen
  const toggleMy26 = (key) => setMy26sel(prev => ({ ...prev, [key]: !prev[key] }));
  const [openCats, setOpenCats] = useState(() =>
    Object.fromEntries(CATEGORIES.map(c => [c.id, true]))
  );
  const [selectedCol, setSelectedCol] = useState(null); // null = Gesamtübersicht

  const EXCLUSIVE_CATS = new Set(["lack", "felgen", "design"]);
  const setVal = (itemId, col, val) => {
    setMy27(prev => {
      const next = { ...prev };
      const cat = CATEGORIES.find(c => c.items.some(i => i.id === itemId));
      if (cat && EXCLUSIVE_CATS.has(cat.id) && val !== "") {
        cat.items.forEach(i => {
          if (i.id !== itemId) delete next[i.id + "__" + col];
        });
      }
      // Advanced und Maxx schließen sich gegenseitig aus
      if (itemId === "advanced" && val !== "") delete next["maxx__" + col];
      if (itemId === "maxx" && val !== "") delete next["advanced__" + col];
      next[itemId + "__" + col] = val;
      // Modellpreis automatisch mitauswählen wenn noch keiner gewählt
      const modelIds = ["m_60e","m_60","m_60sl","m_85","m_85x","m_85sl","m_85xsl","m_rs"];
      const effectiveCol = col === "–" ? null : col;
      if (effectiveCol && val !== "" && !itemId.startsWith("m_")) {
        const anyModelSelected = modelIds.some(id => next[id + "__–"] && next[id + "__–"] !== "");
        if (!anyModelSelected) {
          const modelId = COL_TO_MODEL_ID[effectiveCol];
          const modelPrice = modelId ? MY27_PREFILLED[modelId + "__–"] : null;
          if (modelId && modelPrice) {
            modelIds.forEach(id => { delete next[id + "__–"]; });
            next[modelId + "__–"] = modelPrice;
          }
        }
      }
      // Wenn alle Nicht-Modell-Werte abgewählt → Modellpreis auch abwählen
      if (val === "" && !itemId.startsWith("m_")) {
        const hasOtherValues = Object.entries(next).some(([k, v]) => {
          if (!v || v === "") return false;
          const id = k.split("__")[0];
          return !id.startsWith("m_") && !id.startsWith("t_");
        });
        if (!hasOtherValues) {
          modelIds.forEach(id => { delete next[id + "__–"]; });
        }
      }
      return next;
    });
  };
  const getVal = (itemId, col) => my27[`${itemId}__${col}`] ?? "";
  const toggleCat = id => setOpenCats(p => ({ ...p, [id]: !p[id] }));

  // Aktive Modell-Spalte NUR aus Modellpreis-Auswahl ableiten
  const activeModelCol = (() => {
    const modelIds = ["m_60e", "m_60", "m_60sl", "m_85", "m_85x", "m_85sl", "m_85xsl", "m_rs"];
    for (const id of modelIds) {
      const val = my27[id + "__–"];
      if (val && val !== "") return MODEL_COL_MAP[id] || null;
    }
    return null;
  })();

  return (
    <div style={{ minHeight: "100vh", background: "#0d1117", color: "#e8e8e8", fontFamily: "'DM Sans','Segoe UI',sans-serif", padding: "20px 12px 60px" }}>
      <style>{`
        .st::-webkit-scrollbar { height: 8px; }
        .st::-webkit-scrollbar-track { background: #161b22; border-radius: 4px; }
        .st::-webkit-scrollbar-thumb { background: #4caf00; border-radius: 4px; min-width: 40px; }
        .st::-webkit-scrollbar-thumb:hover { background: #66d100; }
        .st { scrollbar-width: auto; scrollbar-color: #4caf00 #161b22; overflow-x: scroll; }
        input:focus { border-color: #4caf00 !important; box-shadow: 0 0 0 2px rgba(76,175,0,0.15); }
      `}</style>

      {/* Header */}
      <div style={{ maxWidth: 1100, margin: "0 auto 18px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <div style={{ background: "#4caf00", color: "#000", fontWeight: 900, fontSize: 12, letterSpacing: 2, padding: "4px 10px", borderRadius: 3 }}>SKODA</div>
          <div style={{ color: "#8b949e", fontSize: 12 }}>ELROQ</div>
        </div>
        <h1 style={{ fontSize: 22, fontWeight: 800, margin: 0, letterSpacing: -0.5 }}>Preisvergleich MY26 → MY27</h1>
        <p style={{ color: "#8b949e", fontSize: 12, margin: "5px 0 0", lineHeight: 1.5 }}>
          Preisvergleich MY26 vs. MY27 vollständig · Anklicken · Vergleichen · Stand 23.04.2026 · v5.0
        </p>
      </div>

      {/* Info-Banner Technische Daten */}
      <div style={{ maxWidth: 1100, margin: "0 auto 16px", background: "#0f1a0f", border: "1px solid #1e3a1e", borderRadius: 8, padding: "10px 14px", display: "flex", gap: 10, alignItems: "flex-start" }}>
        <span style={{ fontSize: 14, flexShrink: 0 }}>📋</span>
        <div style={{ fontSize: 11, color: "#6dba6d", lineHeight: 1.6 }}>
          <strong style={{ color: "#4caf00" }}>Technische Daten MY27 bereits vorausgefüllt</strong>. Basierend auf Presseinformation (Stand 25.03.2026) · <b>Modellspezifisch:</b> Elroq 60 — NMC → LFP · 140 kW · max. 105 kW DC | Elroq 85 — Anhängelast 1.000/1.200 → 1.800/1.800 kg | Elroq RS — 84 → 82 kWh brutto · max. 185 → 165 kW DC · <b>Alle Modelle neu ab MY27:</b> Infotainment-Upgrade (Android) · Frunk (21 L) · V2L · One Pedal Driving · Digitaler Fahrzeugschlüssel · Qi2-Phonebox · Travel Assist 3.0 · Neue Radarsensoren · Innenraumkamera
        </div>
      </div>

      {/* Legend */}
      <div style={{ maxWidth: 1100, margin: "0 auto 16px" }}>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 8 }}>
          {COLS.map(col => (
            <div key={col} style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <div style={{ width: 9, height: 9, borderRadius: 2, background: COL_COLORS[col], flexShrink: 0 }} />
              <span style={{ fontSize: 11, color: "#888" }}>{COL_LABELS[col]}</span>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ fontSize: 11, color: "#4caf00", fontWeight: 700 }}>Serie</span>
              <span style={{ fontSize: 10, color: "#8b949e" }}>= immer enthalten, nicht abwählbar</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>0€</span>
              <span style={{ fontSize: 10, color: "#8b949e" }}>= Basiswahl, im Preis enthalten aber ersetzbar</span>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <span style={badge("#1e3a2e","#4ade80")}>= gleich</span>
            <span style={badge("#3a1e1e","#f87171")}>+ teurer</span>
            <span style={badge("#1e2e3a","#60a5fa")}>− günstiger</span>
            <span style={badge("#2a1e0e","#fbbf24")}>→ geändert</span>
  
          </div>
        </div>
      </div>

      {/* Model Filter */}
      <div style={{ maxWidth: 1100, margin: "0 auto 16px" }}>
        <div style={{ fontSize: 11, color: "#8b949e", marginBottom: 8 }}>Modell auswählen für die Einzelansicht</div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
        <select
          value={selectedCol || ""}
          onChange={e => {
            setSelectedCol(e.target.value || null);
            setMy27({...INITIAL_MY27});
            setMy26sel({});
          }}
          style={{
            background: "#161b22",
            border: selectedCol ? "2px solid #4caf00" : "2px solid #2d5a2d",
            borderRadius: 8,
            color: selectedCol ? "#4caf00" : "#8b949e", padding: "8px 14px",
            fontSize: 13, fontWeight: selectedCol ? 600 : 400, cursor: "pointer",
            outline: "none", flex: 1, minWidth: 180,
            boxShadow: "0 0 8px rgba(76,175,0,0.18)",
            transition: "all 0.2s",
          }}
        >
          <option value="">Alle Modelle anzeigen</option>
          {COLS.map(col => (
            <option key={col} value={col}>Elroq {COL_LABELS[col]}</option>
          ))}
        </select>

        <button
          onClick={() => { setSelectedCol(null); setMy27({...INITIAL_MY27}); setMy26sel({}); }}
          style={{
            background: "#161b22",
            border: selectedCol ? "2px solid #4caf00" : "2px solid #2d5a2d",
            borderRadius: 8,
            color: selectedCol ? "#4caf00" : "#8b949e",
            padding: "8px 16px", fontSize: 13, fontWeight: selectedCol ? 600 : 400,
            cursor: "pointer", whiteSpace: "nowrap",
            boxShadow: "0 0 8px rgba(76,175,0,0.18)",
            transition: "all 0.2s",
          }}
        >
          ← Gesamtübersicht
        </button>
      </div>
      </div>

      {/* Categories */}
      <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", flexDirection: "column", gap: 10 }}>
        {CATEGORIES.map(cat => {
          const isOpen = openCats[cat.id];
          const isModelle = cat.id === "modelle";
          const isTechnik = cat.id === "technik";
          // Technik & Modelle have special layouts
          // All other categories use full COLS so tables align vertically
          const activeCols = selectedCol ? [selectedCol] : COLS;
          const isSingle = activeCols.length === 1;

          return (
            <div key={cat.id} style={{ background: "#161b22", border: "1px solid #30363d", borderRadius: 10, overflow: "hidden" }}>
              <button onClick={() => toggleCat(cat.id)} style={{ width: "100%", background: "none", border: "none", cursor: "pointer", padding: "12px 16px", display: "flex", alignItems: "center", gap: 10, color: "#e8e8e8" }}>
                <span style={{ fontSize: 16 }}>{cat.icon}</span>
                <span style={{ fontWeight: 700, fontSize: 13 }}>{cat.label}</span>
                
                <span style={{ marginLeft: "auto", color: "#8b949e", fontSize: 14 }}>{isOpen ? "▲" : "▼"}</span>
              </button>

              {isOpen && (
                <div className="st" style={{ paddingBottom: 6 }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
                    <thead>
                      <tr style={{ background: "#0d1117" }}>
                        <th style={{ padding: "6px 14px", textAlign: "left", color: "#8b949e", fontWeight: 600, fontSize: 9, letterSpacing: 1, whiteSpace: "nowrap", minWidth: isModelle ? 240 : isTechnik ? 180 : 260, width: isModelle ? 240 : isTechnik ? 180 : 260 }}>
                          {isModelle ? "MODELL" : isTechnik ? "EIGENSCHAFT" : "OPTION"}
                        </th>
                        {isModelle ? (
                          <>
                            <th style={{ ...thS("#8b949e"), minWidth: 80 }}>MY26</th>
                            <th style={{ padding: "3px 14px", textAlign: "left", color: "#888", fontWeight: 700, fontSize: 9, borderLeft: "2px solid #30363d", whiteSpace: "nowrap" }}>MODELL</th>
                            <th style={{ ...thS("#4caf00"), minWidth: 80 }}>MY27</th>
                            <th style={{ ...thS("#444"), minWidth: 55, width: 55 }}>DIFF</th>
                          </>
                        ) : (
                          activeCols.map((col, ci) => (
[
                              <th key={col+"_l"} style={{ borderLeft: "2px solid #30363d", borderTop: "2px solid #30363d", padding: "6px 6px" }} />,
                              <th key={col} style={{ padding: "6px 6px", textAlign: "center", color: COL_COLORS[col], fontWeight: 700, fontSize: 9, letterSpacing: 0.5, borderTop: "2px solid #30363d", whiteSpace: "nowrap" }}>
                                {COL_LABELS[col]}
                              </th>,
                              <th key={col+"_r"} style={{ borderRight: "2px solid #30363d", borderTop: "2px solid #30363d", padding: "6px 6px" }} />,
                            ]
                          ))
                        )}
                      </tr>
                      {!isModelle && (
                        <tr style={{ background: "#0d1117", borderBottom: "1px solid #30363d" }}>
                          <th style={{ padding: "3px 14px" }} />
                          {activeCols.flatMap((col, ci) => [
                            <th key={col+"_26"} style={{ ...thS("#8b949e"), borderLeft: "2px solid #30363d", textAlign: "center", minWidth: isSingle ? 120 : 60, width: isSingle ? 120 : 60 }}>MY26</th>,
                            <th key={col+"_27"} style={{ ...thS("#4caf00"), minWidth: isSingle ? 120 : 60, width: isSingle ? 120 : 60, textAlign: "center" }}>MY27</th>,
                            <th key={col+"_df"} style={{ ...thS("#444"), borderRight: "2px solid #30363d", paddingRight: 6, minWidth: isSingle ? 90 : 55, width: isSingle ? 90 : 55 }}>DIFF</th>,
                          ])}
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      {cat.items.filter(item => {
                        if (!selectedCol || !isModelle) return true;
                        return MODEL_COL_MAP[item.id] === selectedCol;
                      }).map((item, idx) => {
                        const rowBg = idx % 2 === 0 ? "#161b22" : "#0d1117";
                        return (
                          <tr key={item.id} style={{ background: rowBg, borderBottom: "1px solid #21262d" }}>
                            <td style={{ padding: "8px 14px", width: 260, minWidth: 260 }}>
                              <div style={{ color: "#ccc", fontWeight: 500, whiteSpace: "nowrap" }}>{item.label}{item.newMY27 && <span style={{ marginLeft: 6, fontSize: 9, fontWeight: 700, color: "#4caf00", background: "#0f1a0f", border: "1px solid #1e3a1e", padding: "1px 6px", borderRadius: 10 }}>NEU</span>}</div>
                              {item.hint && (Array.isArray(item.hint) ? item.hint : [item.hint]).map((line, i) => <div key={i} style={{ color: "#555", fontSize: 9, marginTop: i === 0 ? 2 : 1, whiteSpace: "nowrap" }}>{line}</div>)}
                            </td>

                            {isModelle ? (() => {
                              const v26 = item.my26["–"];
                              const inputVal = getVal(item.id, "–");
                              return [
                                <td key="26" style={{ padding: "7px 10px", textAlign: "center", fontWeight: 600, whiteSpace: "nowrap", minWidth: 80 }}>
                                  {v26 === null
                                    ? <span style={{ color: "#252525" }}>–</span>
                                    : <span style={{ color: "#e8e8e8" }}>{v26.toLocaleString("de-DE")} €</span>}
                                </td>,
                                <td key="modlbl27" style={{ padding: "7px 14px", color: "#e8e8e8", fontWeight: 500, whiteSpace: "nowrap", borderLeft: "2px solid #30363d" }}>{item.label27}</td>,
                                <td key="27" style={{ padding: "4px 6px", textAlign: "center", minWidth: 88 }}>
                                  {MY27_PREFILLED[item.id + "__–"] !== undefined ? (() => {
                                    const pv = MY27_PREFILLED[item.id + "__–"];
                                    const isSel = inputVal === pv;
                                    const handleModelClick = () => {
                                      if (isSel) {
                                        // Alles zurücksetzen — Modellpreis + alle Pakete
                                        setMy27({...INITIAL_MY27});
                                        setMy26sel({});
                                        return;
                                      }
                                      // Alle anderen Modell-Preise abwählen
                                      setMy27(prev => {
                                        const next = { ...prev };
                                        ["m_60e","m_60","m_60sl","m_85","m_85x","m_85sl","m_85xsl","m_rs"].forEach(id => { delete next[id + "__–"]; });
                                        next[item.id + "__–"] = pv;
                                        return next;
                                      });
                                      setMy26sel({});
                                    };
                                    return <button onClick={handleModelClick} style={{ width: "100%", background: isSel ? "#0f2d1c" : "#161b22", border: `1px solid ${isSel ? "#4caf00" : "#30363d"}`, borderRadius: 5, color: isSel ? "#4caf00" : "#8b949e", padding: "4px 6px", fontSize: 11, cursor: "pointer", fontWeight: isSel ? 700 : 400, boxShadow: isSel ? "0 0 8px rgba(76,175,0,0.25)" : "none", transition: "all 0.15s" }}>{parseInt(pv).toLocaleString("de-DE")} €</button>;
                                  })() : <input type="text" value={inputVal} onChange={e => setVal(item.id, "–", e.target.value)} placeholder="—" style={inputStyle(!!inputVal)} />}
                                </td>,
                                <td key="df" style={{ padding: "7px 8px", textAlign: "center", minWidth: 55, width: 55 }}>
                                  {inputVal
                                    ? (v26 === null
                                        ? <span style={{ background: "#0f2d1c", color: "#4caf00", padding: "2px 6px", borderRadius: 4, fontSize: 10, fontWeight: 700 }}>NEU</span>
                                        : <PriceDiff my26={v26} my27raw={inputVal} />)
                                    : <span style={{ color: "#2a2a2a" }}>—</span>}
                                </td>,
                              ];
                            })() : activeCols.flatMap(col => {
                              const v26 = item.my26[col];
                              const isAvail = v26 !== null && v26 !== undefined;
                              const inputVal = getVal(item.id, col);
                              const isText = item.type === "text";
                              const techMY27Only = isTechnik && !isAvail && INITIAL_MY27[item.id + "__" + col] !== undefined;
                              if (techMY27Only) {
                                const val27 = INITIAL_MY27[item.id + "__" + col];
                                return [
                                  <td key={col+"_26"} style={{ padding: "6px 6px", textAlign: "center", borderLeft: "2px solid #30363d" }}><span style={{ color: "#252525" }}>–</span></td>,
                                  <td key={col+"_27"} style={{ padding: "3px 4px", textAlign: "center", minWidth: 90 }}>
                                    <span style={{ color: "#10b981", fontSize: 11, whiteSpace: "nowrap", display: "block", textAlign: "center", padding: "3px 4px", background: "#0f1a12", border: "1px solid #1e4a30", borderRadius: 4, minWidth: 90 }}>{val27}</span>
                                  </td>,
                                  <td key={col+"_df"} style={{ padding: "6px 6px", textAlign: "center", borderRight: "2px solid #30363d" }}><span style={{ color: "#252525" }}>–</span></td>,
                                ];
                              }
                              // MY26 nicht vorhanden aber MY27 neu verfügbar → Button anzeigen
                              const preKeyNew = item.id + "__" + col;
                              const pvNew = MY27_PREFILLED[preKeyNew];
                              // Special: MY26=Serie but MY27=paid (e.g. transport RS)
                              const MY26_SERIE_MY27_PAID = new Set(["transport__RS"]);
                              if (!isAvail && !isTechnik && pvNew !== undefined) {
                                if (MY26_SERIE_MY27_PAID.has(preKeyNew)) {
                                  const isSelSP = inputVal === pvNew;
                                  const dispValSP = parseInt(pvNew).toLocaleString("de-DE") + " €";
                                  const isBlockedSP = activeModelCol !== null && activeModelCol !== col && !isSelSP;
                                  return [
                                    <td key={col+"_26"} style={{ padding: "6px 6px", textAlign: "center", borderLeft: "2px solid #30363d" }}><span style={{ color: "#4caf00", fontWeight: 700, fontSize: 11 }}>Serie</span></td>,
                                    <td key={col+"_27"} style={{ padding: "3px 2px", textAlign: "center", minWidth: 60, width: 60 }}>
                                      <button onClick={() => !isBlockedSP && setVal(item.id, col, isSelSP ? "" : pvNew)} style={{ width: "100%", background: isSelSP ? "#0f2d1c" : "#161b22", border: "1px solid " + (isSelSP ? "#4caf00" : "#30363d"), borderRadius: 5, color: isSelSP ? "#4caf00" : "#8b949e", padding: "3px 4px", fontSize: 10, cursor: isBlockedSP ? "default" : "pointer", fontWeight: isSelSP ? 700 : 400, opacity: isBlockedSP ? 0.75 : 1, pointerEvents: isBlockedSP ? "none" : "auto", whiteSpace: "nowrap" }}>{dispValSP}</button>
                                    </td>,
                                    <td key={col+"_df"} style={{ padding: "6px 6px", textAlign: "center", borderRight: "2px solid #30363d" }}>
                                      {isSelSP ? <PriceDiff my26={0} my27raw={pvNew} /> : <span style={{ color: "#2a2a2a" }}>—</span>}
                                    </td>,
                                  ];
                                }
                                if (MY27_BASIS_ONLY.has(preKeyNew)) {
                                  return [
                                    <td key={col+"_26"} style={{ padding: "6px 6px", textAlign: "center", borderLeft: "2px solid #30363d" }}><span style={{ color: "#252525" }}>–</span></td>,
                                    <td key={col+"_27"} style={{ padding: "3px 4px", textAlign: "center", minWidth: 60 }}><span style={{ color: "#94a3b8", fontWeight: 500, fontSize: 11 }}>0€</span></td>,
                                    <td key={col+"_df"} style={{ padding: "6px 6px", textAlign: "center", borderRight: "2px solid #30363d" }}><span style={{ color: "#252525" }}>–</span></td>,
                                  ];
                                }
                                if (MY27_SERIE_ONLY.has(preKeyNew)) {
                                  return [
                                    <td key={col+"_26"} style={{ padding: "6px 6px", textAlign: "center", borderLeft: "2px solid #30363d" }}><span style={{ color: "#252525" }}>–</span></td>,
                                    <td key={col+"_27"} style={{ padding: "3px 4px", textAlign: "center", minWidth: 60 }}><span style={{ color: "#4caf00", fontWeight: 700, fontSize: 11 }}>Serie</span></td>,
                                    <td key={col+"_df"} style={{ padding: "6px 6px", textAlign: "center", borderRight: "2px solid #30363d" }}><span style={{ color: "#252525" }}>–</span></td>,
                                  ];
                                }
                                const isSelNew = inputVal === pvNew;
                                const dispValNew = pvNew === "0" ? "Serie" : parseInt(pvNew).toLocaleString("de-DE") + " €";
                                return [
                                  <td key={col+"_26"} style={{ padding: "6px 6px", textAlign: "center", borderLeft: "2px solid #30363d" }}>
                                    <span style={{ color: "#252525" }}>–</span>
                                  </td>,
                                  <td key={col+"_27"} style={{ padding: "3px 2px", textAlign: "center", minWidth: 60 }}>
                                    {(() => { const isBlockedNew = activeModelCol !== null && activeModelCol !== col && !isSelNew; return <button onClick={() => !isBlockedNew && setVal(item.id, col, isSelNew ? "" : pvNew)} style={{ width: "100%", background: isSelNew ? "#0f2d1c" : "#161b22", border: `1px solid ${isSelNew ? "#4caf00" : "#30363d"}`, borderRadius: 5, color: isSelNew ? "#4caf00" : isBlockedNew ? "#3a3a3a" : "#8b949e", padding: "3px 4px", fontSize: 10, cursor: isBlockedNew ? "default" : "pointer", fontWeight: isSelNew ? 700 : 400, boxShadow: isSelNew ? "0 0 8px rgba(76,175,0,0.25)" : "none", transition: "all 0.15s", whiteSpace: "nowrap", opacity: isBlockedNew ? 0.75 : 1, pointerEvents: isBlockedNew ? "none" : "auto" }}>{dispValNew}</button>; })()}
                                  </td>,
                                  <td key={col+"_df"} style={{ padding: "6px 6px", textAlign: "center", borderRight: "2px solid #30363d" }}>
                                    {isSelNew ? <span style={{ background: "#0f2d1c", color: "#4caf00", padding: "2px 6px", borderRadius: 4, fontSize: 10, fontWeight: 700 }}>NEU</span> : <span style={{ color: "#2a2a2a" }}>—</span>}
                                  </td>,
                                ];
                              }
                              return [
                                <td key={col+"_26"} style={{ padding: "6px 6px", textAlign: "center", borderLeft: "2px solid #30363d", whiteSpace: "nowrap" }}>
                                  {isAvail ? (() => {
                                    if (isText) return <span style={{ color: "#7dd3fc", whiteSpace: "nowrap", fontSize: 11 }}>{v26}</span>;
                                    const fmt = fmtPrice(v26, item.id);
                                    if (fmt === "__SERIE__") return <span style={{ color: "#4caf00", fontWeight: 700, fontSize: 11 }}>Serie</span>;
                                    if (fmt === "__BASIS__") return <span style={{ color: "#94a3b8", fontWeight: 500, fontSize: 11 }}>0€</span>;
                                    // Transport MY26: wenn Advanced oder Maxx gewählt → inklusive
                                    const eligible26 = ["60", "60 SL", "85", "85x", "85 SL", "85x SL"].includes(col);
                                    if (item.id === "transport" && eligible26) {
                                      const advSel = my27["advanced__" + col];
                                      const maxxSel = my27["maxx__" + col];
                                      if ((advSel && advSel !== "") || (maxxSel && maxxSel !== "")) {
                                        return <span><span style={{ textDecoration: "line-through", color: "#555", fontSize: 10 }}>{fmt}</span> <span style={{ color: "#4caf00", fontSize: 9, fontWeight: 700 }}>inkl.</span></span>;
                                      }
                                    }
                                    // MY26 bedingte Preisänderung (z.B. Winter wenn Maxx gewählt)
                                    const condP26 = getConditionalPrice26(item.id, col, my27);
                                    if (condP26 !== null) {
                                      return <span style={{ color: "#e8e8e8", fontSize: 11, whiteSpace: "nowrap" }}>{condP26.toLocaleString("de-DE")} €<span style={{ color: "#555", textDecoration: "line-through", fontSize: 9, marginLeft: 4 }}>{fmt}</span></span>;
                                    }
                                    // MY26 Betrag anklickbar wenn MY27 jetzt Serie ist
                                    const my26selKey = item.id + "__" + col;
                                    if (MY27_SERIE_ONLY.has(my26selKey)) {
                                      const isMy26Sel = !!my26sel[my26selKey];
                                      const isBlocked26 = activeModelCol !== null && activeModelCol !== col && !isMy26Sel;
                                      if (isBlocked26) return <span style={{ color: "#e8e8e8", fontSize: 11, whiteSpace: "nowrap", opacity: 0.75 }}>{fmt}</span>;
                                      return <button onClick={() => toggleMy26(my26selKey)} style={{ background: isMy26Sel ? "#0f1e2a" : "#0d1117", border: "1px solid " + (isMy26Sel ? "#58a6ff" : "#21262d"), borderRadius: 3, color: isMy26Sel ? "#58a6ff" : "#555", fontSize: 9, padding: "1px 5px", cursor: "pointer", whiteSpace: "nowrap", fontWeight: isMy26Sel ? 700 : 400, display: "inline-flex", alignItems: "center", gap: 3 }}>{!isMy26Sel && <span style={{ fontSize: 8, opacity: 0.7 }}>+</span>}{fmt}</button>;
                                    }
                                    return <span style={{ color: "#e8e8e8", fontSize: 11, whiteSpace: "nowrap" }}>{fmt}</span>;
                                  })() : <span style={{ color: "#252525" }}>–</span>}
                                </td>,
                                <td key={col+"_27"} style={{ padding: "3px 2px", textAlign: "center", minWidth: isTechnik ? 90 : 60, width: isTechnik ? 90 : 60 }}>
                                  {isAvail ? (() => {
                                    const preKey = item.id + "__" + col;
                                    const pv = MY27_PREFILLED[preKey];

                                    // MY26 ist Basis oder Serie → kein MY27 Eingabefeld
                                    const fmt26 = fmtPrice(v26, item.id);
                                    const preKeyFull2 = item.id + "__" + col;

                                    if (pv !== undefined && !isTechnik) {
                                      // Nicht mehr verfügbar in MY27
                                      if (MY27_UNAVAILABLE.has(preKeyFull2)) {
                                        return <span style={{ color: "#252525" }}>–</span>;
                                      }
                                      // Basis-only: zeigt 0€ ohne Klick
                                      if (MY27_BASIS_ONLY.has(preKeyFull2)) {
                                        return <span style={{ color: "#94a3b8", fontWeight: 500, fontSize: 11 }}>0€</span>;
                                      }
                                      // Serie-only: nicht anklickbar (auch wenn MY26 bereits Serie war)
                                      if (MY27_SERIE_ONLY.has(preKeyFull2)) {
                                        return <span style={{ color: "#4caf00", fontWeight: 700, fontSize: 11 }}>Serie</span>;
                                      }
                                    }

                                    if (!isTechnik && (fmt26 === "__BASIS__" || fmt26 === "__SERIE__")) {
                                      // Prüfe ob BASIS_ONLY oder SERIE_ONLY zuerst
                                      if (MY27_BASIS_ONLY.has(preKeyFull2) && MY27_PREFILLED[preKeyFull2] !== undefined) {
                                        return <span style={{ color: "#94a3b8", fontWeight: 500, fontSize: 11 }}>0€</span>;
                                      }
                                      if (MY27_SERIE_ONLY.has(preKeyFull2) && MY27_PREFILLED[preKeyFull2] !== undefined) {
                                        return <span style={{ color: "#4caf00", fontWeight: 700, fontSize: 11 }}>Serie</span>;
                                      }
                                      return <span style={{ color: "#252525" }}>–</span>;
                                    }

                                    if (pv !== undefined && !isTechnik) {
                                      const preKeyFull = preKeyFull2;
                                      const condPrice = getConditionalPrice(item.id, col, my27);
                                      const effectivePrice = condPrice !== null ? condPrice : pv;
                                      const isSel = inputVal === effectivePrice || inputVal === pv;
                                      const dispVal = effectivePrice === "0" || effectivePrice === "serie" ? "Serie" : parseInt(effectivePrice).toLocaleString("de-DE") + " €";
                                      const hasDiscount = condPrice !== null && condPrice !== pv;
                                      const isBlocked = activeModelCol !== null && activeModelCol !== col && !isSel;
                                      return <button onClick={() => !isBlocked && setVal(item.id, col, isSel ? "" : effectivePrice)} style={{ width: "100%", background: isSel ? "#0f2d1c" : "#161b22", border: `1px solid ${isSel ? "#4caf00" : "#30363d"}`, borderRadius: 5, color: isSel ? "#4caf00" : isBlocked ? "#3a3a3a" : "#8b949e", padding: "3px 4px", fontSize: 10, cursor: isBlocked ? "default" : "pointer", fontWeight: isSel ? 700 : 400, boxShadow: isSel ? "0 0 8px rgba(76,175,0,0.25)" : "none", transition: "all 0.15s", whiteSpace: "nowrap", opacity: isBlocked ? 0.75 : 1, pointerEvents: isBlocked ? "none" : "auto" }}>
                                        {hasDiscount && !isSel && <span style={{ textDecoration: "line-through", color: "#555", marginRight: 4, fontSize: 9 }}>{parseInt(pv).toLocaleString("de-DE")}€</span>}
                                        {dispVal}
                                      </button>;
                                    }
                                    return isTechnik
                                      ? <span style={{ color: inputVal ? "#7dd3fc" : "#30363d", fontSize: 11, whiteSpace: "nowrap", display: "block", textAlign: "center", padding: "3px 4px", background: inputVal ? "#0f1e2a" : "#161b22", border: `1px solid ${inputVal ? "#1e3a4a" : "#21262d"}`, borderRadius: 4, minWidth: 90 }}>{inputVal || "—"}</span>
                                      : <input type="text" value={inputVal} onChange={e => setVal(item.id, col, e.target.value)} placeholder="—" style={{
                                          ...inputStyle(!!inputVal),
                                          fontSize: 10,
                                          whiteSpace: "nowrap",
                                          background: inputVal ? "#1a2a1a" : "#1a1a1a",
                                          borderColor: inputVal ? "#2d4a2d" : "#222",
                                        }} />;
                                  })() : <span style={{ color: "#252525" }}>–</span>}
                                </td>,
                                <td key={col+"_df"} style={{ padding: "6px 6px", textAlign: "center", borderRight: "2px solid #30363d", whiteSpace: "nowrap", minWidth: 55, width: 55 }}>
                                  {isAvail && inputVal
                                    ? isText
                                      ? <TextDiff my26={v26} my27raw={inputVal} itemId={item.id} />
                                      : <PriceDiff my26={v26} my27raw={inputVal} />
                                    : <span style={{ color: "#2a2a2a" }}>—</span>}
                                </td>,
                              ];
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* ── Kalkulator ─────────────────────────────────────────────────────── */}
      {(() => {
        const { activeCol, sum26, sum27, diff, count, multiModel, activeCols } = useKalkulator(my27, my26sel, MY26_LOOKUP);
        const fmt = n => n.toLocaleString("de-DE") + " €";
        const diffPos = diff > 0;
        const diffZero = diff === 0;

        // Color logic: MY26 box - was it cheaper or more expensive vs MY27?
        // MY27 box - is it cheaper or more expensive vs MY26?
        const my26Color = diffZero ? "#f59e0b" : diff > 0 ? "#4ade80" : "#f87171";
        const my26Bg    = diffZero ? "#2a1e0e" : diff > 0 ? "#1e3a2e" : "#3a1e1e";
        const my27Color = diffZero ? "#f59e0b" : diff > 0 ? "#f87171" : "#4ade80";
        const my27Bg    = diffZero ? "#2a1e0e" : diff > 0 ? "#3a1e1e" : "#1e3a2e";
        const diffColor = diffZero ? "#f59e0b" : diff > 0 ? "#f87171" : "#4ade80";
        const diffBg    = diffZero ? "#2a1e0e" : diff > 0 ? "#3a1e1e" : "#1e3a2e";

        return (
          <div style={{ maxWidth: 1100, margin: "24px auto 0" }}>
            {/* Hinweis SERIE_ONLY — dauerhaft */}
            <div style={{ background: "#2a1010", border: "1px solid #f87171", borderRadius: 8, padding: "8px 14px", marginBottom: 12, fontSize: 10, color: "#f87171", lineHeight: 1.6 }}>
              <span style={{ fontWeight: 700, marginRight: 6 }}>!</span>
              Hinweis: Positionen die in der MY27-Spalte <span style={{ color: "#4caf00", fontWeight: 700, background: "#0f1a0f", border: "1px solid #1e3a1e", padding: "1px 6px", borderRadius: 4, fontSize: 9 }}>Serie</span> geworden sind, waren in MY26 kostenpflichtig. Um einen direkten Preisvergleich zu ermöglichen, können diese MY26-Beträge durch Anklicken in die Kalkulation einbezogen werden.
            </div>

            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
              <div style={{ height: 1, flex: 1, background: "#21262d" }} />
              <span style={{ fontSize: 11, fontWeight: 700, color: "#8b949e", letterSpacing: 1.5 }}>KONFIGURATIONS-KALKULATOR</span>
              <div style={{ height: 1, flex: 1, background: "#21262d" }} />
            </div>

            {/* Warning: multiple models */}
            {multiModel && (
              <div style={{ background: "#3a1e1e", border: "1px solid #f87171", borderRadius: 8, padding: "10px 14px", marginBottom: 14, fontSize: 11, color: "#f87171" }}>
                ⚠️ Werte aus mehreren Modellvarianten erkannt ({activeCols.map(([c,n]) => `${c}: ${n}`).join(" · ")}). Kalkulation basiert auf <strong>{activeCol}</strong>. Bitte nur eine Modellvariante konfigurieren.
              </div>
            )}

            {/* Model badge */}
            <div style={{ textAlign: "center", marginBottom: 16 }}>
              {count === 0
                ? <span style={{ fontSize: 11, color: "#8b949e", background: "#161b22", border: "1px solid #30363d", padding: "3px 12px", borderRadius: 20, letterSpacing: 1 }}>
                    MY27-Preise eintragen um Kalkulation zu starten
                  </span>
                : <span style={{ fontSize: 11, color: "#4caf00", fontWeight: 700, background: "#0f1a0f", border: "1px solid #1e3a1e", padding: "3px 12px", borderRadius: 20, letterSpacing: 1 }}>
                    Elroq {activeCol} · {count} Position{count !== 1 ? "en" : ""} konfiguriert
                  </span>
              }
            </div>

            {/* Three boxes — waagrecht, mobile-optimiert */}
            <div style={{ display: "flex", gap: 8, alignItems: "flex-start", flexWrap: "nowrap" }}>

              {/* MY26 */}
              <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 6 }}>
                <div style={{ textAlign: "center", fontSize: 10, fontWeight: 700, color: "#8b949e", letterSpacing: 1 }}>MY26</div>
                <div style={{ background: count === 0 ? "#161b22" : my26Bg, border: `1px solid ${count === 0 ? "#30363d" : my26Color + "40"}`, borderRadius: 10, padding: "12px 8px", textAlign: "center" }}>
                  <div style={{ fontSize: 8, color: my26Color, letterSpacing: 0.3, marginBottom: 4, opacity: 0.8, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {diffZero ? "" : diff > 0 ? "WAR GÜNSTIGER" : "WAR TEURER"}
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: count === 0 ? "#30363d" : my26Color, fontFamily: "'Space Mono', monospace", letterSpacing: -0.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {count === 0 ? "– –" : fmt(sum26)}
                  </div>
                </div>
              </div>

              {/* Differenz mittig unten */}
              <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end", paddingTop: 24 }}>
                <div style={{ fontSize: 10, fontWeight: 700, color: "#8b949e", letterSpacing: 1, marginBottom: 6 }}>DELTA</div>
                <div style={{ background: count === 0 ? "#161b22" : diffBg, border: `1px solid ${count === 0 ? "#30363d" : diffColor + "40"}`, borderRadius: 10, padding: "12px 8px", textAlign: "center", width: "100%" }}>
                  <div style={{ fontSize: 8, color: diffColor, letterSpacing: 0.3, marginBottom: 4, opacity: 0.8, whiteSpace: "nowrap" }}>
                    {diffZero ? "KEINE ÄND." : diff > 0 ? "TEURER" : "GÜNSTIGER"}
                  </div>
                  <div style={{ fontSize: 15, fontWeight: 800, color: count === 0 ? "#30363d" : diffColor, fontFamily: "'Space Mono', monospace", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {count === 0 ? "– –" : (diff > 0 ? "+" : "") + fmt(diff)}
                  </div>
                  {count > 0 && sum26 > 0 && (
                    <div style={{ fontSize: 9, color: diffColor, opacity: 0.75, marginTop: 3, whiteSpace: "nowrap" }}>
                      {(diff > 0 ? "+" : "") + ((diff / sum26) * 100).toFixed(1) + " %"}
                    </div>
                  )}
                </div>
              </div>

              {/* MY27 */}
              <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 6 }}>
                <div style={{ textAlign: "center", fontSize: 10, fontWeight: 700, color: "#4caf00", letterSpacing: 1 }}>MY27</div>
                <div style={{ background: count === 0 ? "#161b22" : my27Bg, border: `1px solid ${count === 0 ? "#30363d" : my27Color + "40"}`, borderRadius: 10, padding: "12px 8px", textAlign: "center" }}>
                  <div style={{ fontSize: 8, color: my27Color, letterSpacing: 0.3, marginBottom: 4, opacity: 0.8, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {diffZero ? "" : diff > 0 ? "JETZT TEURER" : "JETZT GÜNSTIGER"}
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: count === 0 ? "#30363d" : my27Color, fontFamily: "'Space Mono', monospace", letterSpacing: -0.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {count === 0 ? "– –" : fmt(sum27)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Footer */}
      <div style={{ maxWidth: 1100, margin: "24px auto 0", borderTop: "1px solid #21262d", paddingTop: 16, display: "flex", flexDirection: "column", alignItems: "center", gap: 5 }}>
        <div style={{ color: "#8b949e", fontSize: 10, letterSpacing: 0.5 }}>
          Alle Angaben ohne Gewähr · Quellen: Offizielle Preis- und Ausstattungsübersicht | Stand 16.10.2025 (Elroq 60/60 Sportline) · Stand 23.01.2026 (MY26) · Stand 23.04.2026 (MY27)
        </div>
        <div style={{ color: "#4caf00", fontSize: 10, letterSpacing: 2, fontWeight: 700 }}>
          ERSTELLT VON YLCNGNG
        </div>
      </div>
    </div>
  );
}
